var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center pa-3 primary--text"},[_c('v-progress-circular',{attrs:{"indeterminate":""}}),_c('h5',{staticClass:"mt-2"},[_vm._v("Cargando Datos")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }